import React, { useContext, useEffect, useState, useCallback } from "react";
import Application from "../../StateContext/Application";
import { apiurl } from "../../../../path";
import { useNavigate } from "react-router-dom";
import {
  Cancel32,
  Approved32,
  DeleteRed32,
  submit,
} from "../../../../../src/public/LoginImages/importimages";

// 28-09
import {
  FaMapMarkerAlt,
  FaRegCalendarAlt,
  FaRegClock,
  FaMountain,
  FaBullseye,
  FaChartBar,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";
import { TbLocation } from "react-icons/tb";


const ProgressReportInward = () => {
  // 28-09
const [currentSlide, setCurrentSlide] = useState(0);
  const CARD_THEMES = [
  { border: "#3b82f6", bg: "#f3f8ff", iconBg: "#dbeafe", icon: "#3b82f6" }, // blue
  { border: "#8b5cf6", bg: "#f6f4ff", iconBg: "#e9e4ff", icon: "#8b5cf6" }, // purple
  { border: "#22a55a", bg: "#f2fbf5", iconBg: "#d5f3e0", icon: "#22a55a" }, // green
  { border: "#f59e0b", bg: "#fffaf0", iconBg: "#fdebc8", icon: "#f59e0b" }, // orange
];

const InfoRow = ({ icon, label, value, theme }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: "8px",
      marginBottom: "7px",
      fontSize: "11px",
    }}
  >
    <span
      style={{
        width: "20px",
        height: "20px",
        borderRadius: "50%",
        backgroundColor: theme.iconBg,
        color: theme.icon,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "10px",
        flexShrink: 0,
      }}
    >
      {icon}
    </span>
    <span>
      <b>{label}:</b> {value}
    </span>
  </div>
);
// -----------------

  const operation = useContext(Application);
  const {
    GetBudgetHeadInfo,
    GetProgressReportList,
    ApproveProgressReport,
    Usermenu,
  } = operation;
  const t = (text) => text;
  const nav = useNavigate();
  // ----- data / list state -----
  const [progressReports, setProgressReports] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  // ----- selection / pagination -----
  const [selectedBills, setSelectedBills] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  // ----- reject flow -----
  const [remark, setRemark] = useState("");
  // ----- photo viewer -----
  const [showSpecific, setShowSpecific] = useState(0);
  const [selectedUploadId, setSelectedUploadID] = useState();
  const [FetchedImages, setFetchedImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  // 0 = hidden, 2 = reject panel, 3 = sendback modal
  const [rejectPanelhide, setRejectpanelhide] = useState(0);
  // ==============================
  const [menuData, setMenuData] = useState({});
  useEffect(() => {
    const getMenu = async () => {
      const res = await Usermenu();
      console.log(res);
      setMenuData(res.Data);
    };

    getMenu();
  }, []);

  //const loginData = JSON.parse(sessionStorage.getItem("UserData"));
  const isMaker =
    menuData?.Department_Name === "New Agency Maker" &&
    menuData?.Role === "New Agency Maker";
  console.log("menuData", menuData);
  const isChecker =
    menuData?.Department_Name === "New Agency Checker" &&
    menuData?.Role === "New Agency Checker";

  // ==============================
  // Fetch Progress Report List
  // ==============================
  const getitemList = useCallback(async () => {
    setLoading(true);
    try {
      const result = await GetProgressReportList();
      if (result?.Status) {
        let data = result.Data || [];
        // State Maker -> Rejected Only
        if (isMaker) {
          data = data.filter((item) => item.Status === "Rejected");
        }

        // State Checker -> Pending Only
        else if (isChecker) {
          data = data.filter((item) => item.Status === "Pending");
        }
        setProgressReports(data);
        setFilteredBills(data);
      }
    } catch (error) {
      console.error("GetProgressReportList Error:", error);
      alert("Unable to load Progress Report List.");
    } finally {
      setLoading(false);
    }
  }, [GetProgressReportList, isMaker, isChecker]);

  useEffect(() => {
    getitemList();
  }, [getitemList]);
  // ==============================
  // Search filter
  // ==============================
  useEffect(() => {
    const lowerSearchTerm = searchTerm.toLowerCase();

    const filtered = progressReports.filter((row) =>
      Object.values(row).some((val) =>
        (val || "").toString().toLowerCase().includes(lowerSearchTerm),
      ),
    );
    setFilteredBills(filtered);
    setCurrentPage(1);
  }, [searchTerm, progressReports]);
  // ==============================
  // Pagination
  // ==============================

  const totalPages = Math.max(1, Math.ceil(filteredBills.length / rowsPerPage));

  const indexOfFirstBill = (currentPage - 1) * rowsPerPage;

  const indexOfLastBill = indexOfFirstBill + rowsPerPage;

  const currentBills = filteredBills.slice(indexOfFirstBill, indexOfLastBill);

  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [filteredBills, totalPages, currentPage]);
  // ==============================
  const handleCheckboxChange = (id) => {
    setSelectedBills((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
    );
  };
  const handleSelectAll = () => {
    if (currentBills.length === 0) return;
    //const currentPageIds = currentBills.map((row) => row.ID);
    const currentPageIds = currentBills.map((row) => row.UploadID); //163
    const allSelected = currentPageIds.every((id) =>
      selectedBills.includes(id),
    );
    if (allSelected) {
      setSelectedBills((prev) =>
        prev.filter((id) => !currentPageIds.includes(id)),
      );
    } else {
      setSelectedBills((prev) => {
        const merged = [...prev];

        currentPageIds.forEach((id) => {
          if (!merged.includes(id)) merged.push(id);
        });

        return merged;
      });
    }
  };
  // Rows currently selected, matched against the full filtered list (not just this page)
  // const selectedRows = filteredBills.filter((row) =>
  //   selectedBills.includes(row.ID),
  // );
  const selectedRows = filteredBills.filter((row) =>
    selectedBills.includes(row.UploadID),
  );
  const findMHUID = selectedRows.map((r) => r.TechnicalUID);
  const physical = selectedRows.map((r) => r.physicalValue);
  const uploadId = selectedRows.map((r) => r.UploadID);

  // ==============================
  // Approve / Reject submission
  // ==============================
  const approveorrejectSelected = async (condition) => {
    if (selectedBills.length === 0) {
      alert("No Proposal selected for approval!");
      return;
    }

    if (condition === "Rejected" || condition === "SendBack") {
      const cleanRemark = remark.trim().replace(/\s+/g, " ");

      if (!cleanRemark) {
        alert("Remark is required and cannot be empty!");
        return;
      }
    }

    setLoading(true);

    try {
      const response = await ApproveProgressReport(
        selectedBills,
        condition,
        remark,
      );
      console.log("Approve API Response:", response);
      const isSuccess = response?.Status ?? response?.status;
      const successMsg = response?.Message ?? response?.message;
      const errorMsg = response?.Error ?? response?.error;

      if (isSuccess) {
        alert(successMsg || "Success");
        setRemark("");
        setRejectpanelhide(0);
        getitemList();
      } else {
        alert(
          errorMsg || successMsg || "Something went wrong. Please try again.",
        );
        getitemList();
      }
    } catch (error) {
      console.error("Error approving Proposal:", error);
      alert("An error occurred while approving bills.");
    }
    setLoading(false);
  };
  const rejectSendbackbeforecheckup = (id) => {
    if (selectedBills.length <= 0) {
      alert("Please select at least one Work Order.");
      return;
    }

    if (id === 2) {
      setRejectpanelhide(2);
    }

    if (id === 3) {
      setRejectpanelhide(3);
    }
  };
  const closeRejectPanel = () => {
    setRejectpanelhide(0);
    setRemark("");
  };
  // ==============================
  // Photo viewer
  // ==============================
  const fetchSpecficUploadPhoto = async (
    uploadID,
    WorkOrderNo,
    physicalWork,
  ) => {
    try {
      const res = await GetBudgetHeadInfo(
        uploadID,
        "GetSpecificUploadImagesfromProgressTable",
      );

      // const filteredImages = res?.Data || [];
      const filteredImages = (res?.Data || []).filter(
        (item) => item.UploadID === uploadID,
      );
      setFetchedImages(filteredImages);
      setSelectedUploadID(uploadID);
      setCurrentSlide(0); // <-- add this 28-09
      setShowSpecific(1);
    } catch (err) {
      console.log(err);
    }
  };

  const parseUploads = (upload) => {
    try {
      if (Array.isArray(upload)) return upload;
      return JSON.parse(upload || "[]");
    } catch {
      return [];
    }
  };

  const parseLocations = (location) => {
    try {
      if (Array.isArray(location)) {
        return location.map((loc) =>
          typeof loc === "string" ? JSON.parse(loc) : loc,
        );
      }
      const parsed = JSON.parse(location || "[]");
      return parsed.map((loc) =>
        typeof loc === "string" ? JSON.parse(loc) : loc,
      );
    } catch {
      return [];
    }
  };
  // Go to a project's map view
  const navigatetoMap = (projectId) => {
    if (!projectId) return;

    nav(`/AdminDashboard/MapFunction/${projectId}`, {
      state: {
        from: "ProgressReport",
      },
    });
  };

  const getPageNumbers = () => {
    const pages = [];

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }

      return pages;
    }

    // Starting pages
    // 1 2 3 4 5 ... Last
    if (currentPage <= 3) {
      pages.push(1, 2, 3, 4, 5);
      pages.push("...");
      pages.push(totalPages);

      return pages;
    }

    // Last pages
    // ... 16 17 18 19 20
    if (currentPage >= totalPages - 2) {
      pages.push("...");

      for (let i = totalPages - 4; i <= totalPages; i++) {
        pages.push(i);
      }

      return pages;
    }

    // Middle pages
    // ... 4 5 6 7 8 ... 20
    pages.push("...");

    pages.push(
      currentPage - 2,
      currentPage - 1,
      currentPage,
      currentPage + 1,
      currentPage + 2,
    );

    pages.push("...");
    pages.push(totalPages);

    return pages;
  };

  return (
    <>
      <style>
        {`
    * {
      box-sizing: border-box;
    }

    html,
    body,
    #root {
      width: 100%;
      max-width: 100%;
      margin: 0;
      padding: 0;
    }

    .progress-report-page {
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      margin: 0 !important;
      padding: 0 20px 30px !important;
      box-sizing: border-box !important;
      overflow-x: hidden !important;
         height:90vh;
    }

    .progress-report-content {
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      box-sizing: border-box !important;
    }

    .progress-report-header {
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      margin: 16px 0 20px !important;
      padding: 0 !important;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 20px;
      box-sizing: border-box;
    }

    .progress-report-card {
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      margin: 0 !important;
      padding: 20px !important;
      box-sizing: border-box !important;
      overflow: hidden;
    }

   
.progress-report-table-wrapper {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  height: 380px;
  overflow-x: auto !important;
  overflow-y: auto !important;
  box-sizing: border-box !important;
  border: 1px solid #D9DEEF;
  border-radius: 8px;
  position: relative;
}
 
 
   .inward-table {
  width: 100%;
  min-width: 1450px;
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0;
}
 
.inward-table thead th {
  position: sticky;
  top: 0;
  z-index: 10;
  // 28/10
  background-color: #2D79D9;
color: #FFFFFF;
  white-space: nowrap !important;
  padding: 10px 8px;
  height: 58px;
  text-align: center;
  vertical-align: middle;
  font-size: 13px;
  font-weight: 700;
}
 
.inward-table tbody td {
  padding: 8px;
  text-align: center;
  vertical-align: middle;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border-right: 1px solid #E5E7EF;
  border-bottom: 1px solid #E5E7EF;
}
 
/* Project name, work name and description */
.inward-table tbody td:nth-child(5),
.inward-table tbody td:nth-child(7),
.inward-table tbody td:nth-child(10) {
  white-space: normal;
  overflow-wrap: anywhere;
}
 
//28/10
    .inward-table tbody tr:nth-child(even) td {
  background-color: #CEE4F1;
}

.inward-table tbody tr:nth-child(odd) td {
  background-color: #E5F2FC;
}

    .inward-table th:last-child,
    .inward-table td:last-child {
      border-right: none;
    }

    .progress-report-pagination {
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0 !important;
      padding: 20px 5px !important;
      box-sizing: border-box;
    }

    @media (max-width: 768px) {
      .progress-report-page {
        padding: 0 10px 20px !important;
      }

      .progress-report-header {
        flex-direction: column;
        align-items: stretch;
      }

      .progress-report-search {
        width: 100% !important;
        max-width: 100% !important;
      }

      .progress-report-card {
        padding: 12px !important;
      }

      .progress-report-pagination {
        flex-direction: column;
        gap: 15px;
        align-items: flex-start;
      }
    }
  
    .progress-report-outer-container {
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* Internet Explorer */
    }

    .progress-report-outer-container::-webkit-scrollbar {
      display: none; /* Chrome, Edge, Safari */
    }

    
  `}
      </style>

      {showSpecific === 0 && (
        
        <div
          style={{
            width: "100%",
            // maxWidth: "100%",
            // minWidth: 0,
            flex: "1 1 auto",
            // minHeight: "calc(90vh - 80px)",
            height:"90vh",
            background: "#ffffff",
            overflowX: "hidden",
            overflowY: "auto",
            padding: "0 20px 30px",
            margin: 0,
            boxSizing: "border-box",
            fontFamily: "Inter, sans-serif",
          }}
        >
          {/* //29/10 */}
         <div
  className="progress-report-outer-container"
  style={{
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    padding: "20px",
    margin: "20px 0 0",
    boxSizing: "border-box",
    backgroundColor: "#EEF3F8",
    border: "1px solid #D9E2EF",
    borderRadius: "10px",
  }}
>
       {/* //29/10 */}
            <div
              style={{
                width: "100%",
                maxWidth: "100%",
                minWidth: 0,
                padding: "0",
                margin: "16px 0 20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "20px",
                boxSizing: "border-box",
              }}
            >
              <h5
                style={{
                  margin: 0,
                  fontWeight: 700,
                  display: "flex",
                  alignItems: "center",
                  whiteSpace: "nowrap",
                }}
              >
                <img
                  src={"/List-32.png"}
                  alt="Project Icon"
                  style={{
                    marginRight: "10px",
                    width: 28,
                    height: 28,
                    flexShrink: 0,
                  }}
                />
                <span>Progress Report Inward</span>
              </h5>

              <div
                style={{
                  position: "relative",
                  width: "250px",
                  maxWidth: "250px",
                  flexShrink: 0,
                }}
              >
                <img
                  src="/Search32.png"
                  alt="Search Icon"
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "10px",
                    transform: "translateY(-50%)",
                    width: "16px",
                    height: "16px",
                    opacity: 0.6,
                    pointerEvents: "none",
                  }}
                />

                <input
                  type="text"
                  placeholder="Search Here"
                  onChange={(e) => setSearchTerm(e.target.value)}
                  value={searchTerm}
                  style={{
                    width: "100%",
                    height: "38px",
                    padding: "8px 12px 8px 32px",
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    fontSize: "12px",
                    color: "#333",
                    outline: "none",
                    boxSizing: "border-box",
                  }}
                />
              </div>
            </div>

            {loading && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background: "rgba(255,255,255,0.7)",
                  zIndex: 9999,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    border: "6px solid #f3f3f3",
                    borderTop: "6px solid #007bff",
                    borderRadius: "50%",
                    width: "60px",
                    height: "60px",
                    animation: "spin 1s linear infinite",
                  }}
                />
                <style>{`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}</style>
              </div>
            )}
            <div
              className="m-auto mb-3"
              style={{
                backgroundColor: "white",
                padding: "25px 25px 20px",
                boxShadow: "0px 0px 8px rgba(0,0,0,0.12)",
                borderRadius: "10px",
                width: "100%",
                maxWidth: "100%",
                minWidth: 0,
                boxSizing: "border-box",
                overflow: "hidden",
              }}
            >
              {/* <div
                className="col-12"
                style={{
                  width: "100%",
                  maxWidth: "100%",
                  minWidth: 0,
                  overflowX: "auto",
                  overflowY: "hidden",
                  border: "1px solid #D9DEEF",
                  borderRadius: "8px",
                }}
              > */}
              <div
                className="col-12 progress-report-table-wrapper"
                  style={{
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    height: currentBills.length > 0 ? "380px" : "auto",
    overflowX: "auto",
    overflowY: currentBills.length > 0 ? "auto" : "hidden",
    border: "1px solid #D9DEEF",
    borderRadius: "8px",
  }}>
                {/* <table
                  className="m-0 p-0 inward-table"
                  style={{
                    width: "100%",
                    minWidth: "1050px",
                    borderCollapse: "separate",
                    borderSpacing: "0",
                    backgroundColor: "#FFFFFF",
                  }}
                > */}
                  <table
  className="m-0 p-0 inward-table"
  style={{
    width: "100%",
    minWidth: "1100px",
    tableLayout: "fixed",
    borderCollapse: "separate",
    borderSpacing: "0",
    backgroundColor: "#FFFFFF",
  }}
>
 
<colgroup>
  <col style={{ width: "70px" }} />  {/* Checkbox */}
  <col style={{ width: "100px" }} /> {/* Sr No */}
  <col style={{ width: "120px" }} /> {/* Financial Year */}
  <col style={{ width: "100px" }} /> {/* ProjectID */}
   <col style={{ width: "200px" }} /> {/* Project Name */}
  <col style={{ width: "100px" }} /> {/* Scheme */}
   <col style={{ width: "200px" }} /> {/* Work Name */}
   <col style={{ width: "350px" }} />{/* Location */}
  <col style={{ width: "180px" }} /> {/* Physical Progress */}
   <col style={{ width: "200px" }} /> {/* Description */}
  {isMaker && <col style={{ width: "120px" }} />} {/* Remark */}
  <col style={{ width: "120px" }} /> {/* View MAP */}
</colgroup>
 
 
                  <thead>
                    <tr
                      style={{
                        //28/10
                        backgroundColor:"#2D79D9",
                        color: "white",
                        border: "none",
                        height: "3rem",
                        fontSize: "14px",
                        fontWeight:"600", alignItems:'center', 
                         width: "100px", whiteSpace:"nowrap" 
                      }}
                    >
                      <th
  style={{
    padding: "8px",
    textAlign: "center",
    verticalAlign: "middle",
  }}
>
  <input
    type="checkbox"
    onChange={handleSelectAll}
    checked={
      currentBills.length > 0 &&
      currentBills.every((row) =>
        selectedBills.includes(row.UploadID)
      )
    }
    style={{
      width: "16px",
      height: "16px",
      display: "block",
      margin: "0 auto",
      cursor: "pointer",
    }}
  />
</th>
                      <th >Sr No</th>
                      <th >Financial Year</th>
                      <th>ProjectID</th>
                      <th>Project Name</th>
                      <th>Scheme</th>
                      <th>Work Name</th>
                      <th style={{width:"150px"}}>Location</th>
                      <th>Physical Progress(%)</th>
                      <th>Description</th>
                      {isMaker && <th>Remark</th>}
                      {/* <th>Action</th> */}
                      <th >View MAP</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentBills.length <= 0 ? (
                      <tr>
                        {/* <td
                          colSpan="13"
                          style={{
                            textAlign: "center",
                            padding: "15px",
                            backgroundColor: "#f9f9f9",
                          }}
                        >
                          No data available
                        </td> */}
                      </tr>
                    ) : (
                      currentBills.map((row, index) => {
                        //28/10
                        const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CEE4F1";
                        const uploadedFiles = parseUploads(row.Upload);

                        return (
                          <tr
                            style={{
                              backgroundColor: bgColor,
                              fontSize: "14px",
                            }}
                            key={row.ID}
                          >
                            <td style={{ textAlign: "center" }}>
                              <input
                                type="checkbox"
                                disabled={
                                  row.ID === null || row.ID === undefined
                                }
                                // checked={selectedBills.includes(row.ID)}
                                // onChange={() => handleCheckboxChange(row.ID)}
                                checked={selectedBills.includes(row.UploadID)}
                                onChange={() =>
                                  handleCheckboxChange(row.UploadID)
                                }
                              />
                            </td>
                            <td>{indexOfFirstBill + index + 1}</td>
                            <td>{row.FinancialYear}</td>
                            <td style={{color:"#5295c9"}}>{row.ProjectID}</td>
                            
                            <td  style={{
    padding: 10,
    whiteSpace: "normal",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    maxWidth: "200px",
    lineHeight: "1.4",
  }}>{row.ProjectName}</td>
                            <td>{row.Scheme}</td>
                            <td style={{
    padding: 10,
    whiteSpace: "normal",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    maxWidth: "200px",
    lineHeight: "1.4",
  }}>{row.WorkName}</td>
                            <td style={{whiteSpace:"normal",width:"150px"}}>
                              {row.StartCoordinates && row.EndCoordinates ? (
                                <>
                                  <div>
                                    <strong>Start :</strong>{" "}
                                    {JSON.parse(row.StartCoordinates).join(
                                      ", ",
                                    )}
                                  </div>
                                  <div>
                                    <strong>End :</strong>{" "}
                                    {JSON.parse(row.EndCoordinates).join(", ")}
                                  </div>
                                </>
                              ) : (
                                "Area Not Selected"
                              )}
                            </td>
                            <td>
 <button
                                className="btn btn-success px-3"
                                onClick={() =>
                                  fetchSpecficUploadPhoto(
                                    row.UploadID,
                                    row.WorkOrderNo,
                                    row.PhysicalProgress,
                                  )
                                }
                                style={{
                                  fontSize: "12px",
                                  background:
                                    "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                                  color: "white",
                                  border: "none",
                                  padding: "6px 12px",
                                  borderRadius: "8px",
                                  display: "inline-flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  gap: "4px",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {t("View Photos")}
                                {/* {row.PhysicalProgress} % */}
                              </button>
                            </td>
                            <td  style={{
    padding: 10,
    whiteSpace: "normal",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    maxWidth: "200px",
    lineHeight: "1.4",
  }}>{row.Description}</td>
                            {isMaker && <td>{row.Remark}</td>}
                            {/* <td
                              style={{ padding: "10px", textAlign: "center" }}
                            >
                              <button
                                className="btn btn-success px-3"
                                onClick={() =>
                                  fetchSpecficUploadPhoto(
                                    row.UploadID,
                                    row.WorkOrderNo,
                                    row.PhysicalProgress,
                                  )
                                }
                                style={{
                                  fontSize: "12px",
                                  background:
                                    "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                                  color: "white",
                                  border: "none",
                                  padding: "6px 12px",
                                  borderRadius: "8px",
                                  display: "inline-flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  gap: "4px",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {t("View Photos")}
                              </button>
                            </td> */}
                            <td
                              style={{ padding: "10px", textAlign: "center" }}
                            >
                              <button
                                onClick={() => navigatetoMap(row.ProjectID)}
                                style={{
                                  cursor: "pointer",
                                  background:
                                    "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                                  color: "white",
                                  border: "none",
                                  padding: "6px 10px",
                                  borderRadius: "8px",
                                  fontSize: "12px",
                                  display: "inline-flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  gap: "4px",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {t("Go to Map")}
                              </button>
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
                    {(!Array.isArray(currentBills) || currentBills.length === 0) && (
                        <div
                            style={{
                                position: "sticky",
                                left: 0,
                                width: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "150px",
                                boxSizing: "border-box",
                                backgroundColor: "#ffffff",
                                color: "#333",
                                fontSize: "14px",
                                fontWeight: 500,
                            }}
                        >
                            No data available
                        </div>
                    )}
              </div>

              <div className="col-12 mt-3">
                <div className="row">
                  <div
                    className="my-2"
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                    }}
                  >
                    <button
                      type="button"
                      className="ms-0"
                      onClick={() => approveorrejectSelected("Approved")}
                      disabled={selectedBills.length <= 0 || loading}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.3rem",
                        margin: "12px",
                        padding: "8px 10px",
                        fontWeight: "600",
                        backgroundColor:
                          selectedBills.length <= 0 ? "#f3eeee" : "#39B54A",

                        color: selectedBills.length > 0 ? "#ffffff" : "#01B574",
                        border: "1px solid #39B54A",
                        borderRadius: "8px",
                        cursor:
                          selectedBills.length <= 0
                            ? "not-allowed"
                            : loading
                              ? "not-allowed"
                              : "pointer",
                      }}
                    >
                      {loading ? (
                        t("Processing...")
                      ) : (
                        <>
                          <img
                            src={Approved32}
                            alt="Approve"
                            style={{
                              width: "18px",
                              height: "18px",
                              flexShrink: 0,
                            }}
                          />
                          {t("Approve Selected")}
                        </>
                      )}
                    </button>

                    {isChecker && (
                      <button
                        type="button"
                        onClick={() => rejectSendbackbeforecheckup(2)}
                        disabled={selectedBills.length <= 0 || loading}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.3rem",
                          margin: "12px",
                          padding: "8px 10px",
                          fontWeight: "600",
                          backgroundColor:
                            selectedBills.length <= 0 ? "#f3eeee" : "#C1272D",

                          color: selectedBills.length > 0 ? "#ffffff" : "red",
                          border: "1px solid #ff6b81",
                          borderRadius: "8px",
                          borderRadius: "8px",
                          cursor:
                            selectedBills.length <= 0
                              ? "not-allowed"
                              : loading
                                ? "not-allowed"
                                : "pointer",
                        }}
                      >
                        <img
                          src={DeleteRed32}
                          alt="Reject"
                          style={{
                            width: "18px",
                            height: "18px",
                            filter:
                              selectedBills.length > 0
                                ? "brightness(0) invert(1)"
                                : "none",
                            flexShrink: 0,
                          }}
                        />
                        {loading ? "Processing..." : t("Reject Selected")}
                      </button>
                    )}
                  </div>
                </div>

                {rejectPanelhide === 2 && (
                  <div
                    className="col-12 RejectPanelContainer"
                    style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background: "rgba(0, 0, 0, 0.35)",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      zIndex: 9999,
                    }}
                  >
                    <div
                      className="Rejectpanel"
                      style={{
                        width: "500px",
                        background: "#fff",
                        borderRadius: "10px",
                        padding: "20px",
                        boxShadow: "0 0 15px rgba(0,0,0,0.2)",
                      }}
                    >
                      <form onSubmit={(e) => e.preventDefault()}>
                        <div className="col-12 elements">
                          <div className="row">
                            <div className="col-3">
                              <label className="fw-bold">
                                Remark <span className="text-danger">*</span>
                              </label>
                            </div>
                            <div className="col-8">
                              <textarea
                                name="Remark"
                                value={remark}
                                placeholder="Enter Remark"
                                onChange={(e) => setRemark(e.target.value)}
                              ></textarea>
                            </div>
                          </div>
                        </div>
                      </form>
                      <div className="col-12 ms-auto my-4">
                        <div className="row">
                          <div className="col-9 m-auto">
                            <div
                              className="col-12"
                              style={{
                                display: "flex",
                                gap: "10px",
                                justifyContent: "center",
                              }}
                            >
                              <button
                                type="button"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  gap: "4px",
                                  background:
                                    "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                                  width: "5rem",
                                  height: "2rem",
                                  fontSize: "18px",
                                }}
                                onClick={() =>
                                  approveorrejectSelected("Rejected")
                                }
                              >
                                <img
                                  src={submit}
                                  style={{ width: "15px" }}
                                  alt=""
                                />{" "}
                                Reject
                              </button>
                              <button
                                type="button"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  gap: "4px",
                                  backgroundColor: "#f1594c",
                                  width: "6rem",
                                  height: "2rem",
                                  fontSize: "16px",
                                }}
                                onClick={closeRejectPanel}
                              >
                                <img
                                  src={Cancel32}
                                  style={{ width: "17px" }}
                                  alt=""
                                />
                                Cancel
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {rejectPanelhide === 3 && (
                  <div
                    className="col-12 RejectPanelContainer"
                    style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background: "rgba(0, 0, 0, 0.35)",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      zIndex: 9999,
                    }}
                  >
                    <div
                      className="Rejectpanel"
                      style={{
                        width: "500px",
                        background: "#fff",
                        borderRadius: "10px",
                        padding: "20px",
                        boxShadow: "0 0 15px rgba(0,0,0,0.2)",
                      }}
                    >
                      <form onSubmit={(e) => e.preventDefault()}>
                        <div className="col-12 elements">
                          <div className="row">
                            <div className="col-3">
                              <label className="fw-bold">
                                Remark <span className="text-danger">*</span>
                              </label>
                            </div>
                            <div className="col-8">
                              <textarea
                                name="Remark"
                                value={remark}
                                placeholder="Enter Remark"
                                onChange={(e) => setRemark(e.target.value)}
                              ></textarea>
                            </div>
                          </div>
                        </div>
                      </form>
                      <div className="col-12 ms-auto my-4">
                        <div className="row">
                          <div className="col-9 m-auto">
                            <div
                              className="col-12"
                              style={{
                                display: "flex",
                                gap: "10px",
                                justifyContent: "center",
                              }}
                            >
                              <button
                                type="button"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  gap: "4px",
                                  backgroundColor:
                                    selectedBills.length <= 0
                                      ? "#f3eeee"
                                      : "#3127c1",
                                  border: "1px solid blue",

                                  width: "8rem",
                                  height: "2rem",
                                  fontSize: "18px",
                                }}
                                onClick={() =>
                                  approveorrejectSelected("SendBack")
                                }
                              >
                                <img
                                  src={submit}
                                  style={{ width: "15px" }}
                                  alt=""
                                />{" "}
                                Send Back
                              </button>
                              <button
                                type="button"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  gap: "4px",
                                  backgroundColor: "#f1594c",
                                  width: "6rem",
                                  height: "2rem",
                                  fontSize: "16px",
                                }}
                                onClick={closeRejectPanel}
                              >
                                <img
                                  src={Cancel32}
                                  style={{ width: "17px" }}
                                  alt=""
                                />
                                Cancel
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Table pagination */}
                {/* ---- Pagination ---- */}

                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: "0px",
                    padding: "20px 5px",
                    boxSizing: "border-box",
                  }}
                >
                  {/* ================= SHOWING ENTRIES ================= */}

                  <div
                    style={{
                      fontSize: "13px",
                      color: "#333",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Showing{" "}
                    {filteredBills?.length === 0 ? 0 : indexOfFirstBill + 1} to{" "}
                    {Math.min(indexOfLastBill, filteredBills?.length || 0)} of{" "}
                    {filteredBills?.length || 0} entries
                  </div>

                  {/* ================= PAGINATION ================= */}

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "18px",
                    }}
                  >
                    {/* Previous */}

                    <button
                      type="button"
                      onClick={() =>
                        setCurrentPage((prev) => Math.max(prev - 1, 1))
                      }
                      disabled={currentPage === 1}
                      style={{
                        border: "none",
                        background: "transparent",
                        color: "#2ea4e7",
                        cursor: currentPage === 1 ? "not-allowed" : "pointer",
                        fontSize: "13px",
                        padding: 0,
                        opacity: currentPage === 1 ? 0.5 : 1,
                      }}
                    >
                      ‹ Previous
                    </button>

                    {/* Page Numbers */}

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "20px",
                      }}
                    >
                      {getPageNumbers().map((pageNumber, index) => {
                        // Dots
                        if (pageNumber === "...") {
                          return (
                            <span
                              key={`dots-${index}`}
                              style={{
                                color: "#444",
                                fontSize: "13px",
                              }}
                            >
                              ...
                            </span>
                          );
                        }

                        // Page Number
                        return (
                          <button
                            type="button"
                            key={pageNumber}
                            onClick={() => setCurrentPage(pageNumber)}
                            style={{
                              border: "none",
                              background: "transparent",
                              padding: 0,
                              color:
                                currentPage === pageNumber ? "#2ea4e7" : "#444",
                              cursor: "pointer",
                              fontSize: "13px",
                              fontWeight:
                                currentPage === pageNumber ? "600" : "400",
                              textDecoration:
                                currentPage === pageNumber
                                  ? "underline"
                                  : "none",
                            }}
                          >
                            {pageNumber}
                          </button>
                        );
                      })}
                    </div>

                    {/* Next */}

                    <button
                      type="button"
                      onClick={() =>
                        setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                      }
                      disabled={currentPage === totalPages || totalPages <= 1}
                      style={{
                        border: "none",
                        background: "transparent",
                        color: "#2ea4e7",
                        cursor:
                          currentPage === totalPages || totalPages <= 1
                            ? "not-allowed"
                            : "pointer",
                        fontSize: "13px",
                        padding: 0,
                        opacity:
                          currentPage === totalPages || totalPages <= 1
                            ? 0.5
                            : 1,
                      }}
                    >
                      Next ›
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* {showSpecific === 1 && (
        <div
          className="col-12"
          style={{
            backgroundColor: "#EFF3F8",
            height: "89vh",
            overflowX: "hidden",
            overflowY: "scroll",
          }}
        >
          <div className="col-11 m-auto">
            <div className="col-12 PartSection">
              <div className="col-12 py-4">
                <div
                  className="col-12"
                  style={{
                    backgroundColor: "white",
                    borderRadius: "8px",
                    padding: "20px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    marginBottom: "20px",
                  }}
                >
                  <h5 className="text-center fw-bold my-4">
                    {t("Upload ID")} : {selectedUploadId}
                  </h5>

                  <div className="col-10 m-auto ImageContainer">
                    <div className="row justify-content-center">
                      {FetchedImages &&
                        FetchedImages.length > 0 &&
                        FetchedImages.map((val, index) => {
                          const images = val.Upload
                            ? val.Upload.split(",").map((img) => img.trim())
                            : [];
                          // const locations = parseLocations(val.Location);
                          //163
                          const locations = (() => {
                            try {
                              if (!val.Location) return [];
                              // Handle simple "lat,long" string
                              if (
                                typeof val.Location === "string" &&
                                val.Location.includes(",") &&
                                !val.Location.startsWith("[")
                              ) {
                                const [lat, lng] = val.Location.split(",");
                                const dt = val.Date ? new Date(val.Date) : null;
                                return [
                                  {
                                    latitude: lat?.trim(),
                                    longitude: lng?.trim(),
                                    date: dt
                                      ? dt.toLocaleDateString("en-GB")
                                      : "-",
                                    time: dt
                                      ? dt.toLocaleTimeString("en-GB", {
                                          hour12: false,
                                        })
                                      : "-",
                                    elevation: "-",
                                    accuracy: "-",
                                  },
                                ];
                              }
                              // Handle JSON format if available
                              return parseLocations(val.Location);
                            } catch {
                              return [];
                            }
                          })();

                          return images.map((img, imgIndex) => {
                            const location = locations[imgIndex] || {};
                            return (
                              <div
                                key={`${index}-${imgIndex}`}
                                className="col-12 col-sm-6 col-md-4 col-lg-3 px-2 my-2"
                              >
                                <div
                                  style={{
                                    border: "1px solid #ddd",
                                    borderRadius: "12px",
                                    padding: "10px",
                                    background: "#fff",
                                  }}
                                >
                                  <div
                                    className="uploadImagesContainer"
                                    style={{
                                      width: "100%",
                                      height: "220px",
                                      borderRadius: "10px",
                                      overflow: "hidden",
                                      cursor: "pointer",
                                      backgroundColor: "#f5f5f5",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                    onClick={() => {
                                      const imageUrl = `${apiurl}/ProgressReport/${img}`;
                                      setSelectedImage(imageUrl);
                                    }}
                                  >
                                    <img
                                      src={`${apiurl}/ProgressReport/${img}`}
                                      alt="Uploaded"
                                      loading="lazy"
                                      decoding="async"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "contain",
                                        display: "block",
                                        imageRendering: "auto",
                                      }}
                                      onError={(e) => {
                                        console.error(
                                          "Image not found:",
                                          e.target.src,
                                        );
                                        e.currentTarget.style.display = "none";
                                      }}
                                    />
                                  </div>
                                  <div
                                    style={{
                                      marginTop: "10px",
                                      fontSize: "13px",
                                      lineHeight: "1.6",
                                    }}
                                  >
                                    <div>
                                      📍 Latitude: {location.latitude || "-"}
                                    </div>
                                    <div>
                                      📍 Longitude: {location.longitude || "-"}
                                    </div>
                                    <div>📅 Date: {location.date || "-"}</div>
                                    <div>🕒 Time: {location.time || "-"}</div>
                                    <div>
                                      ⛰️ Elevation: {location.elevation || "-"}{" "}
                                      m
                                    </div>
                                    <div>
                                      🎯 Accuracy: {location.accuracy || "-"} m
                                    </div>
                                    <div>
                                      📊 Physical Done:{" "}
                                      {val.PhysicalProgress || "-"}%
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          });
                        })}
                    </div>
                  </div>

                  <div className="col-12 text-center">
                    <button
                      type="button"
                      className="btn btn-primary fw-bold px-5 my-4"
                      onClick={() => setShowSpecific(0)}
                    >
                      {t("Back")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )} */}

      {/* 28-09 */}

{showSpecific === 1 && (() => {
  const cards = [];
  (FetchedImages || []).forEach((val, index) => {
    const images = val.Upload
      ? val.Upload.split(",").map((img) => img.trim())
      : [];

    const locations = (() => {
      try {
        if (!val.Location) return [];
        if (
          typeof val.Location === "string" &&
          val.Location.includes(",") &&
          !val.Location.startsWith("[")
        ) {
          const [lat, lng] = val.Location.split(",");
          const dt = val.Date ? new Date(val.Date) : null;
          return [
            {
              latitude: lat?.trim(),
              longitude: lng?.trim(),
              date: dt ? dt.toLocaleDateString("en-GB") : "-",
              time: dt ? dt.toLocaleTimeString("en-GB", { hour12: false }) : "-",
              elevation: "",
              accuracy: "",
            },
          ];
        }
        return parseLocations(val.Location);
      } catch {
        return [];
      }
    })();

    images.forEach((img, imgIndex) => {
      cards.push({
        key: `${index}-${imgIndex}`,
        img,
        // falls back to the first location if a photo has none of its own
        location: locations[imgIndex] || locations[0] || {},
        progress: val.PhysicalProgress,
      });
    });
  });

  const total = cards.length;
  const current = cards[currentSlide] || cards[0];
  const theme = CARD_THEMES[0];
  const goPrev = () => setCurrentSlide((p) => (p - 1 + total) % total);
  const goNext = () => setCurrentSlide((p) => (p + 1) % total);

  const arrowStyle = (side) => ({
    position: "absolute",
    top: "50%",
    [side]: "10px",
    transform: "translateY(-50%)",
    width: "34px",
    height: "34px",
    borderRadius: "50%",
    border: "none",
    backgroundColor: "rgba(255,255,255,0.92)",
    boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
    color: "#333",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    zIndex: 2,
  });

  const location = current?.location || {};

  return (
    <div
      className="col-12"
      style={{
        backgroundColor: "#fff",
        height: "90vh",
        overflowX: "hidden",
        overflowY: "auto",
        padding: "20px 24px",
      }}
    >
      <h6 className="fw-bold mb-4" style={{ fontSize: "20px" ,textAlign:"center"}}>
        {t("Uploaded Id")}: {selectedUploadId}
      </h6>

      {total > 0 && (
        <div
          style={{
            maxWidth: "380px",
            margin: "0 auto",
            border: `1.5px solid ${theme.border}`,
            borderRadius: "10px",
            backgroundColor: theme.bg,
            padding: "10px",
          }}
        >
          {/* ---- Photo slider (only this part slides) ---- */}
          <div
            style={{
              position: "relative",
              width: "100%",
              height: "240px",
              borderRadius: "14px",
              overflow: "hidden",
              backgroundColor: "#eee",
            }}
          >
            <div
              style={{
                display: "flex",
                height: "100%",
                transform: `translateX(-${currentSlide * 100}%)`,
                transition: "transform 0.4s ease",
              }}
            >
              {cards.map((c) => (
                <div
                  key={c.key}
                  style={{ flex: "0 0 100%", height: "100%", cursor: "pointer" }}
                  onClick={() =>
                    setSelectedImage(`${apiurl}/ProgressReport/${c.img}`)
                  }
                >
                  <img
                    src={`${apiurl}/ProgressReport/${c.img}`}
                    alt="Uploaded"
                    loading="lazy"
                    decoding="async"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block",
                    }}
                    onError={(e) => {
                      console.error("Image not found:", e.target.src);
                      e.currentTarget.style.display = "none";
                    }}
                  />
                </div>
              ))}
            </div>

            {total > 1 && (
              <>
                <button type="button" onClick={goPrev} style={arrowStyle("left")} aria-label="Previous">
                  <FaChevronLeft size={14} />
                </button>
                <button type="button" onClick={goNext} style={arrowStyle("right")} aria-label="Next">
                  <FaChevronRight size={14} />
                </button>

                {/* counter badge */}
                <span
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    backgroundColor: "rgba(0,0,0,0.55)",
                    color: "#fff",
                    fontSize: "11px",
                    padding: "2px 8px",
                    borderRadius: "10px",
                  }}
                >
                  {currentSlide + 1} / {total}
                </span>
              </>
            )}
          </div>

          {/* dots */}
          {total > 1 && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "6px",
                margin: "10px 0 4px",
              }}
            >
              {cards.map((c, i) => (
                <span
                  key={c.key}
                  onClick={() => setCurrentSlide(i)}
                  style={{
                    width: i === currentSlide ? "18px" : "8px",
                    height: "8px",
                    borderRadius: "4px",
                    backgroundColor: i === currentSlide ? theme.border : "#cfd4dc",
                    cursor: "pointer",
                    transition: "all 0.3s",
                  }}
                />
              ))}
            </div>
          )}

          {/* ---- Info (static, does not slide) ---- */}
          <div style={{ marginTop: "12px" }}>
            <InfoRow theme={theme} icon={<TbLocation />} label="Latitude" value={location.latitude || "-"} />
            <InfoRow theme={theme} icon={<FaMapMarkerAlt />} label="Longitude" value={location.longitude || "-"} />
            <InfoRow theme={theme} icon={<FaRegCalendarAlt />} label="Date" value={location.date || "-"} />
            <InfoRow theme={theme} icon={<FaRegClock />} label="Time" value={location.time || "-"} />
            <InfoRow theme={theme} icon={<FaMountain />} label="Elevation" value={`${location.elevation && location.elevation !== "-" ? location.elevation : ""} m`} />
            <InfoRow theme={theme} icon={<FaBullseye />} label="Accuracy" value={`${location.accuracy && location.accuracy !== "-" ? location.accuracy : ""} m`} />
            <InfoRow theme={theme} icon={<FaChartBar />} label="Work Done" value={`${current?.progress || "-"}%`} />
          </div>
        </div>
      )}

      <div className="text-center">
        <button
          type="button"
          className="btn btn-primary fw-bold px-5 my-4"
          onClick={() => setShowSpecific(0)}
        >
          {t("Back")}
        </button>
      </div>
    </div>
  );
})()}

      {selectedImage && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.85)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
            padding: "20px",
          }}
          onClick={() => setSelectedImage(null)}
        >
          {/* Close button */}
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              setSelectedImage(null);
            }}
            style={{
              position: "absolute",
              top: "20px",
              right: "25px",
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              border: "none",
              backgroundColor: "rgba(255,255,255,0.9)",
              color: "#000",
              fontSize: "25px",
              fontWeight: "bold",
              cursor: "pointer",
              zIndex: 100000,
            }}
          >
            ×
          </button>

          {/* Full image */}
          <img
            src={selectedImage}
            alt="Uploaded Progress Report"
            draggable={false}
            onClick={(e) => e.stopPropagation()}
            style={{
              display: "block",
              width: "auto",
              height: "auto",
              maxWidth: "95vw",
              maxHeight: "95vh",
              objectFit: "contain",
              borderRadius: "6px",
              boxShadow: "0 0 20px rgba(255,255,255,0.25)",
              imageRendering: "auto",
            }}
            onLoad={(e) => {
              console.log(
                "Original image dimensions:",
                e.currentTarget.naturalWidth,
                "x",
                e.currentTarget.naturalHeight,
              );
            }}
            onError={(e) => {
              console.error("Full image failed:", e.currentTarget.src);
            }}
          />
        </div>
      )}
    </>
  );
};

export default ProgressReportInward;
